"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeight = exports.getFontSize = exports.getBottomTopPadding = exports.Text = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const getFontSize = size => {
  switch (size) {
    case 'large':
      return '1.4rem';
    case 'medium':
      return '1.2rem';
    default:
      return '1rem';
  }
};
exports.getFontSize = getFontSize;
const getBottomTopPadding = size => size === 'small' ? 0.4 : 1;
exports.getBottomTopPadding = getBottomTopPadding;
const getHeight = size => {
  switch (size) {
    case 'large':
      return 32;
    case 'medium':
      return 28;
    default:
      return 20;
  }
};
exports.getHeight = getHeight;
const Root = exports.Root = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isEmpty,
  size,
  theme
}) => ({
  alignItems: 'center',
  background: theme.palette.grey[100],
  display: 'flex',
  height: isEmpty ? getHeight(size) : undefined,
  justifyContent: 'center',
  padding: theme.spacing(getBottomTopPadding(size), 2)
}));
const Text = exports.Text = (0, _mui.styled)('span', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  maxLines,
  size,
  theme
}) => ({
  color: theme.palette.text.primary,
  fontFamily: theme.typography.fontFamily,
  fontSize: getFontSize(size),
  fontWeight: theme.typography.fontWeightBold,
  display: '-webkit-box',
  WebkitLineClamp: maxLines,
  WebkitBoxOrient: 'vertical',
  width: 'auto',
  textTransform: 'uppercase',
  overflow: maxLines ? 'hidden' : 'visible'
}));
